<template>
  <div>
    English Contents
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>